import { useCallback } from "react";
import { NumericTextBoxProps } from "@progress/kendo-react-inputs";

export const useDefaultNumericTextBoxProps = () =>
  useCallback(
    (props: NumericTextBoxProps) => ({
      ...props,
      spinners: false,
    }),
    []
  );
